(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/redux/game-package-slice.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/redux/game-package-slice.js');

'use strict';

const _RTK = RTK,
  createSlice = _RTK.createSlice;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const packageConfig = svs.gamePackage.data.packageConfig;
const packageSizes = packageConfig.packageSizes,
  drawsOptions = packageConfig.drawsOptions,
  _packageConfig$defaul = packageConfig.defaultSelectedIndex,
  defaultSelectedIndex = _packageConfig$defaul === void 0 ? 1 : _packageConfig$defaul,
  title = packageConfig.title;
const _svs$gamePackage$mapp = svs.gamePackage.mappers,
  getPackageDraws = _svs$gamePackage$mapp.getPackageDraws,
  calculatePackagePriceFromConfig = _svs$gamePackage$mapp.calculatePackagePriceFromConfig;
const mapPackageSizes = (_ref, index) => {
  let label = _ref.label,
    gamePackageId = _ref.gamePackageId,
    games = _ref.games,
    tickets = _ref.tickets;
  return {
    label,
    price: calculatePackagePriceFromConfig({
      games,
      tickets
    }),
    gamePackageId,
    index
  };
};
const gamePackageSlice = createSlice({
  name: 'gamePackage',
  initialState() {
    const activeIndex = defaultSelectedIndex;
    const draws = getPackageDraws();
    return {
      sizes: packageSizes.map(mapPackageSizes),
      activeIndex,
      packageIsClosed: !isSelfService && draws.length < drawsOptions.length,
      title
    };
  },
  reducers: {
    updateIndex: (state, action) => {
      state.activeIndex = parseInt(action.payload.activeIndex, 10);
    },
    updateDraws: (state, action) => {
      const draws = action.payload;
      state.packageIsClosed = !isSelfService && draws.length < drawsOptions.length;
    }
  }
});
svs.gamePackage.redux.gamePackageSlice = gamePackageSlice;

 })(window);